import { sessionSoap } from './SessionSoap';
import xml from './Xml';
import type { SoapOptions } from './coreTypes';

let isCollectRequests = false;
let bunchXML: Array<string> = [];
let requestsPromises: Array<{
	resolve: (value?: unknown) => void;
	reject: (reason?: unknown) => void;
}> = [];

const collect = () => {
	isCollectRequests = true;
	bunchXML = [];
	requestsPromises = [];
};

const soap = (requestBody: string, options: SoapOptions = {}) => {
	if (!isCollectRequests || options.method !== 'ApplyItem') {
		return sessionSoap(requestBody, options);
	}

	const promise = new Promise((resolve, reject) => {
		requestsPromises.push({ resolve, reject });
	});

	bunchXML.push(requestBody);
	return promise;
};

const complete = async () => {
	isCollectRequests = false;

	try {
		const resultSoap = await sessionSoap(`<AML>${bunchXML.join('')}</AML>`, {
			method: 'ApplyAML',
			async: true
		});
		const nodes = xml.selectNodes(resultSoap, 'Item');

		if (!nodes) {
			requestsPromises.forEach(({ resolve }) => resolve());
			return;
		}

		requestsPromises.forEach(({ resolve }, i) => {
			const result = xml.parseString(
				`<Result>${xml.getXml(nodes[i])}</Result>`
			);
			resolve(result.documentElement);
		});
	} catch (error) {
		requestsPromises.forEach(({ reject }) => {
			reject(error);
		});
	}
};

export { collect, soap, complete };
